export enum PresetsComponentsEnum {
	confirm = "confirm",
	success = "success",
	fail = "fail",
	pending = "pending",
	pendingTakingLonger = "pending-taking-longer",
	emailMismatch = "email-mismatch"
}
